import { formatUsdBalance, formatUsdBalanceCompact } from '../core/pricing'
import type { Coin } from '../core/types'

/** `compact` shows dollars and cents only, for a figure that is already an estimate. */
export function Money({ coin, suffix, compact = false }: { coin: Coin | null | undefined; suffix?: string; compact?: boolean }) {
  return <span className="money">{(compact ? formatUsdBalanceCompact(coin) : formatUsdBalance(coin)) ?? 'Unavailable'}{suffix ? ` ${suffix}` : ''}</span>
}
